import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "bi bi-arrow-clockwise"
}
const _hoisted_2 = { class: "au-stats" }
const _hoisted_3 = { class: "au-card-title mb-3" }
const _hoisted_4 = { class: "au-stats" }
const _hoisted_5 = { class: "flex-grow-1" }
const _hoisted_6 = { class: "au-shortcut-title" }
const _hoisted_7 = { class: "au-shortcut-text" }
const _hoisted_8 = { class: "flex-grow-1" }
const _hoisted_9 = { class: "au-shortcut-title" }
const _hoisted_10 = { class: "au-shortcut-text" }
const _hoisted_11 = { class: "flex-grow-1" }
const _hoisted_12 = { class: "au-shortcut-title" }
const _hoisted_13 = { class: "au-shortcut-text" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bs5_base_button = _resolveComponent("bs5-base-button")!
  const _component_bs5_page_header = _resolveComponent("bs5-page-header")!
  const _component_bs5_stat_card = _resolveComponent("bs5-stat-card")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_bs5_page_header, {
      title: _ctx.$t('dashboard.greeting', { name: _ctx.firstName }),
      subtitle: _ctx.$t('dashboard.subtitle')
    }, {
      actions: _withCtx(() => [
        _createVNode(_component_bs5_base_button, {
          variant: "secondary",
          loading: _ctx.loading,
          onClick: _ctx.load
        }, {
          default: _withCtx(() => [
            (!_ctx.loading)
              ? (_openBlock(), _createElementBlock("i", _hoisted_1))
              : _createCommentVNode("", true),
            _createTextVNode(_toDisplayString(_ctx.$t("common.refresh")), 1)
          ]),
          _: 1
        }, 8, ["loading", "onClick"])
      ]),
      _: 1
    }, 8, ["title", "subtitle"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_bs5_stat_card, {
        icon: "bi-briefcase-fill",
        tone: "indigo",
        value: _ctx.clientsCount,
        loading: _ctx.loading,
        label: _ctx.$t('dashboard.clients')
      }, null, 8, ["value", "loading", "label"]),
      _createVNode(_component_bs5_stat_card, {
        icon: "bi-shop",
        tone: "cyan",
        value: _ctx.distributorsCount,
        loading: _ctx.loading,
        label: _ctx.$t('dashboard.distributors')
      }, null, 8, ["value", "loading", "label"]),
      (_ctx.isSuperAdmin)
        ? (_openBlock(), _createBlock(_component_bs5_stat_card, {
            key: 0,
            icon: "bi-people-fill",
            tone: "rose",
            value: _ctx.usersCount,
            loading: _ctx.loading,
            label: _ctx.$t('dashboard.users')
          }, null, 8, ["value", "loading", "label"]))
        : _createCommentVNode("", true),
      _createVNode(_component_bs5_stat_card, {
        icon: "bi-shield-check",
        tone: "amber",
        value: _ctx.roleName,
        "is-text": "",
        label: _ctx.$t('dashboard.role')
      }, null, 8, ["value", "label"])
    ]),
    _createElementVNode("h2", _hoisted_3, _toDisplayString(_ctx.$t("dashboard.shortcuts")), 1),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_router_link, {
        class: "au-card au-shortcut",
        to: { name: 'Clients' }
      }, {
        default: _withCtx(() => [
          _cache[0] || (_cache[0] = _createElementVNode("div", { class: "au-tile is-indigo" }, [
            _createElementVNode("i", { class: "bi bi-briefcase-fill" })
          ], -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.$t("nav.clients")), 1),
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("dashboard.goClients")), 1)
          ]),
          _cache[1] || (_cache[1] = _createElementVNode("i", { class: "bi bi-arrow-right" }, null, -1))
        ]),
        _: 1
      }),
      (_ctx.isSuperAdmin)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            class: "au-card au-shortcut",
            to: { name: 'Distributors' }
          }, {
            default: _withCtx(() => [
              _cache[2] || (_cache[2] = _createElementVNode("div", { class: "au-tile is-cyan" }, [
                _createElementVNode("i", { class: "bi bi-shop" })
              ], -1)),
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("nav.distributors")), 1),
                _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("dashboard.goDistributors")), 1)
              ]),
              _cache[3] || (_cache[3] = _createElementVNode("i", { class: "bi bi-arrow-right" }, null, -1))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.isSuperAdmin)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 1,
            class: "au-card au-shortcut",
            to: { name: 'Users' }
          }, {
            default: _withCtx(() => [
              _cache[4] || (_cache[4] = _createElementVNode("div", { class: "au-tile is-rose" }, [
                _createElementVNode("i", { class: "bi bi-people-fill" })
              ], -1)),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("nav.users")), 1),
                _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t("dashboard.goUsers")), 1)
              ]),
              _cache[5] || (_cache[5] = _createElementVNode("i", { class: "bi bi-arrow-right" }, null, -1))
            ]),
            _: 1
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}